import { enableStaticRendering } from 'mobx-react';
import { useMemo } from 'react';

import { Store, initializeStore } from './store';
import { FilterStore } from './filterStore';

enableStaticRendering(typeof window === 'undefined');

/**
 * @typedef {{
 *  mainStore: import('./store').PopulatedStore,
 *  filterStore: import('./filterStore').FilterStoreProps
 * }} RootStore
 */

/** @type {RootStore} */
let store;
export class RootStore {
  constructor() {
    this.mainStore = new Store();
    this.filterStore = new FilterStore();
  }
}

/** @param {Partial<Store> | null} initialData */
export const initializeRootStore = (initialData = null) => {
  const _store = store ?? new RootStore();

  if (initialData) {
    _store.mainStore = initializeStore(initialData)
  }

  if (typeof window === 'undefined') return _store;

  if (!store) store = _store;

  return _store;
};

/** @param {Partial<Store> | null} initialState */
export function useStore(initialState) {
  const store = useMemo(() => initializeRootStore(initialState), [initialState]);
  return store;
}